import { observer } from 'mobx-react'
import React, { ReactElement } from 'react'

import { lazy } from 'react'

const GraphsStoresProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/analytics').then(module => ({
      default: module.GraphsStoresProvider
   }))
)

const BoardStoresProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/boards').then(module => ({
      default: module.BoardStoresProvider
   }))
)

const ListStoresProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/boards').then(module => ({
      default: module.ListStoresProvider
   }))
)

const CallsStoresProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/calls').then(module => ({
      default: module.CallsStoresProvider
   }))
)

const AudioUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/ui').then(module => ({
      default: module.AudioUIStoreProvider
   }))
)

const CloudCallingUIStoreContextProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/ui').then(module => ({
      default: module.CloudCallingUIStoreContextProvider
   }))
)

const NotificationsUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/ui').then(module => ({
      default: module.NotificationsUIStoreProvider
   }))
)

const PermissionsUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/data-access').then(
      module => ({
         default: module.PermissionsUIStoreProvider
      })
   )
)

const RemindersUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/ui').then(module => ({
      default: module.RemindersUIStoreProvider
   }))
)

const TemplateConfigUIStoreContextProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/ui').then(module => ({
      default: module.TemplateConfigUIStoreContextProvider
   }))
)

const ViewRefreshUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/ui').then(module => ({
      default: module.ViewRefreshUIStoreProvider
   }))
)

const FileUploaderUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/ui').then(module => ({
      default: module.FileUploaderUIStoreProvider
   }))
)

const GoogleMapsUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/shared/maps/ui').then(module => ({
      default: module.GoogleMapsUIStoreProvider
   }))
)

const RecordPipelineSelectionUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/ui').then(module => ({
      default: module.RecordPipelineSelectionUIStoreProvider
   }))
)

const SyncAssigneeHierarchyUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/ui').then(module => ({
      default: module.SyncAssigneeHierarchyUIStoreProvider
   }))
)

const CreateRecordUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/application-creation').then(
      module => ({
         default: module.CreateRecordUIStoreProvider
      })
   )
)

const LeadCreationUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/application-creation').then(
      module => ({
         default: module.LeadCreationUIStoreProvider
      })
   )
)

const CRMItemDetailedViewStoresProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/application-detailed-view').then(
      module => ({
         default: module.CRMItemDetailedViewStoresProvider
      })
   )
)

const CompleteFieldResponseUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/shared-web/fields/ui').then(module => ({
      default: module.CompleteFieldResponseUIStoreProvider
   }))
)

const GlobalSearchUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/global-search').then(module => ({
      default: module.GlobalSearchUIStoreProvider
   }))
)

const UserAppConfigStoresProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/iam').then(module => ({
      default: module.UserAppConfigStoresProvider
   }))
)

const UserAttendanceUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/iam').then(module => ({
      default: module.UserAttendanceUIStoreProvider
   }))
)

const LoginSuccessRouteProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/login').then(module => ({
      default: module.LoginSuccessRouteProvider
   }))
)

const NavbarStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/navbar-base').then(module => ({
      default: module.NavbarStoreProvider
   }))
)

// const ExportPipelineItemsUIStoreProvider = lazy(() =>
//    import('@flowwai-frontend/admin-web/agent-operations-hub').then(module => ({
//       default: module.ExportPipelineItemsUIStoreProvider
//    }))
// )

const PipelineItemSchedulingStoresProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/scheduling').then(module => ({
      default: module.PipelineItemSchedulingStoresProvider
   }))
)

const SalesCrmStoresProvider = lazy(() =>
   import('@flowwai-frontend/shared/sales-crm/sales-crm-core').then(module => ({
      default: module.SalesCrmStoresProvider
   }))
)

const ReportBugProvider = lazy(() =>
   import('@flowwai-frontend/shared/common').then(module => ({
      default: module.ReportBugProvider
   }))
)

const SidebarStoreProvider = lazy(() =>
   import('@flowwai-frontend/shared/sidebar').then(module => ({
      default: module.SidebarStoreProvider
   }))
)

const AdminProfileStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/data-access').then(
      module => ({
         default: module.AdminProfileStoreProvider
      })
   )
)

const RecordWisePipelinesStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/data-access').then(
      module => ({
         default: module.RecordWisePipelinesStoreProvider
      })
   )
)

const ApplicationRealTimeStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/data-access').then(
      module => ({
         default: module.ApplicationRealTimeStoreProvider
      })
   )
)

const PipelineLayoutStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/common/data-access').then(
      module => ({
         default: module.PipelineLayoutStoreProvider
      })
   )
)

const EntityVisibilityStoreProvider = lazy(() =>
   import('@flowwai-frontend/shared/sales-crm/sales-crm-core').then(module => ({
      default: module.EntityVisibilityStoreProvider
   }))
)

const DashboardsUIStoreProvider = lazy(() =>
   import('@flowwai-frontend/bps-officer-web/analytics').then(module => ({
      default: module.DashboardsUIStoreProvider
   }))
)

interface StoresProviderProps {
   children: ReactElement
}

const StoresProvider = (props: StoresProviderProps) => {
   const { children } = props

   return (
      <LoginSuccessRouteProvider>
         <NavbarStoreProvider>
            <ApplicationRealTimeStoreProvider>
               <RemindersUIStoreProvider>
                  <NotificationsUIStoreProvider>
                     <SalesCrmStoresProvider>
                        <TemplateConfigUIStoreContextProvider>
                           <UserAppConfigStoresProvider>
                              <UserAttendanceUIStoreProvider>
                                 <CloudCallingUIStoreContextProvider>
                                    <GraphsStoresProvider>
                                       <ViewRefreshUIStoreProvider>
                                          <SidebarStoreProvider>
                                             <ListStoresProvider>
                                                <BoardStoresProvider>
                                                   <CRMItemDetailedViewStoresProvider>
                                                      <AudioUIStoreProvider>
                                                         <CallsStoresProvider>
                                                            <PipelineItemSchedulingStoresProvider>
                                                               <GlobalSearchUIStoreProvider>
                                                                  <LeadCreationUIStoreProvider>
                                                                     <CreateRecordUIStoreProvider>
                                                                        <PermissionsUIStoreProvider>
                                                                           <FileUploaderUIStoreProvider>
                                                                              <GoogleMapsUIStoreProvider>
                                                                                 <CompleteFieldResponseUIStoreProvider>
                                                                                    <SyncAssigneeHierarchyUIStoreProvider>
                                                                                       <RecordPipelineSelectionUIStoreProvider>
                                                                                          <AdminProfileStoreProvider>
                                                                                             <RecordWisePipelinesStoreProvider>
                                                                                                <ReportBugProvider>
                                                                                                   <PipelineLayoutStoreProvider>
                                                                                                      <EntityVisibilityStoreProvider>
                                                                                                         <DashboardsUIStoreProvider>
                                                                                                            {
                                                                                                               children
                                                                                                            }
                                                                                                         </DashboardsUIStoreProvider>
                                                                                                      </EntityVisibilityStoreProvider>
                                                                                                   </PipelineLayoutStoreProvider>
                                                                                                </ReportBugProvider>
                                                                                             </RecordWisePipelinesStoreProvider>
                                                                                          </AdminProfileStoreProvider>
                                                                                       </RecordPipelineSelectionUIStoreProvider>
                                                                                    </SyncAssigneeHierarchyUIStoreProvider>
                                                                                 </CompleteFieldResponseUIStoreProvider>
                                                                              </GoogleMapsUIStoreProvider>
                                                                           </FileUploaderUIStoreProvider>
                                                                        </PermissionsUIStoreProvider>
                                                                     </CreateRecordUIStoreProvider>
                                                                  </LeadCreationUIStoreProvider>
                                                               </GlobalSearchUIStoreProvider>
                                                            </PipelineItemSchedulingStoresProvider>
                                                         </CallsStoresProvider>
                                                      </AudioUIStoreProvider>
                                                   </CRMItemDetailedViewStoresProvider>
                                                </BoardStoresProvider>
                                             </ListStoresProvider>
                                          </SidebarStoreProvider>
                                       </ViewRefreshUIStoreProvider>
                                    </GraphsStoresProvider>
                                 </CloudCallingUIStoreContextProvider>
                              </UserAttendanceUIStoreProvider>
                           </UserAppConfigStoresProvider>
                        </TemplateConfigUIStoreContextProvider>
                     </SalesCrmStoresProvider>
                  </NotificationsUIStoreProvider>
               </RemindersUIStoreProvider>
            </ApplicationRealTimeStoreProvider>
         </NavbarStoreProvider>
      </LoginSuccessRouteProvider>
   )
}

export default observer(StoresProvider)
